// frontend/src/utils/context/detectEmotionAndTone.js

export function detectEmotionAndTone(message = '') {
    const lower = message.toLowerCase();
  
    const emotionScores = {
      sad: 0,
      angry: 0,
      happy: 0,
      anxious: 0,
      spiritual: 0,
    };
  
    const sadnessWords = ['sad', 'miss', 'lonely', 'cry', 'grief', 'mourning'];
    const angerWords = ['angry', 'mad', 'frustrated', 'rage', 'annoyed'];
    const happinessWords = ['happy', 'excited', 'joy', 'grateful', 'cheerful'];
    const anxietyWords = ['overwhelmed', 'anxious', 'stressed', 'panic'];
    const spiritualWords = ['faith', 'pray', 'blessed', 'church', 'spiritual'];
  
    sadnessWords.forEach(word => {
      if (lower.includes(word)) emotionScores.sad += 1;
    });
    angerWords.forEach(word => {
      if (lower.includes(word)) emotionScores.angry += 1;
    });
    happinessWords.forEach(word => {
      if (lower.includes(word)) emotionScores.happy += 1;
    });
    anxietyWords.forEach(word => {
      if (lower.includes(word)) emotionScores.anxious += 1;
    });
    spiritualWords.forEach(word => {
      if (lower.includes(word)) emotionScores.spiritual += 1;
    });
  
    // Pick highest scored emotion
    let bestEmotion = 'neutral';
    let bestScore = 0;
  
    for (const [emotion, score] of Object.entries(emotionScores)) {
      if (score > bestScore) {
        bestEmotion = emotion;
        bestScore = score;
      }
    }
  
    // 🎨 Match tones based on primary emotion
    const toneMap = {
      sad: 'compassionate',
      angry: 'calming',
      happy: 'cheerful',
      anxious: 'grounding',
      spiritual: 'reverent',
      neutral: 'neutral',
    };
  
    const tone = toneMap[bestEmotion] || 'neutral';
  
    return { emotion: bestEmotion, tone };
  }
  